import script from "./PayoffRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayoffRow.vue?vue&type=script&setup=true&lang=ts"

import "./PayoffRow.vue?vue&type=style&index=0&id=27fd3ad0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fd3ad0"]])

export default __exports__